import { render, staticRenderFns } from "./newscompony.vue?vue&type=template&id=eb24f4ca&scoped=true&"
import script from "./newscompony.vue?vue&type=script&lang=js&"
export * from "./newscompony.vue?vue&type=script&lang=js&"
import style0 from "./newscompony.vue?vue&type=style&index=0&id=eb24f4ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb24f4ca",
  null
  
)

export default component.exports